import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14 4V6H4V4H14Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16 6V8H14V10H12V12H10V14H8V12H6V10H4V8H2V6H16Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }